'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', 'px;\n  margin: 0px 15px;\n  cursor: pointer;\n  font-size: 12px;\n  border-style: none none solid none;\n  border-width: 3px;\n  white-space: nowrap;\n  padding-top: 2px;\n  border-color: ', ';\n  color: ', ';\n  font-weight: ', ';\n  text-transform: ', ';\n  position: relative;\n  ', ';\n\n  &:hover {\n    border-color: ', ';\n  }\n'], ['\n  height: ', 'px;\n  margin: 0px 15px;\n  cursor: pointer;\n  font-size: 12px;\n  border-style: none none solid none;\n  border-width: 3px;\n  white-space: nowrap;\n  padding-top: 2px;\n  border-color: ', ';\n  color: ', ';\n  font-weight: ', ';\n  text-transform: ', ';\n  position: relative;\n  ', ';\n\n  &:hover {\n    border-color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var nav = _ref.nav;
  return nav ? 32 : 26;
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? _colors.red : 'transparent';
}, function (_ref3) {
  var selected = _ref3.selected;
  return selected ? _colors.black : _colors.darkGrey;
}, function (_ref4) {
  var nav = _ref4.nav;
  return nav ? 700 : 400;
}, function (_ref5) {
  var nav = _ref5.nav;
  return nav ? 'uppercase' : 'none';
}, (0, _polished.transitions)('border-color .2s ease-in-out, color .2s ease-in-out'), function (_ref6) {
  var selected = _ref6.selected;
  return selected ? _colors.red : _colors.grey;
});

var Tab = function Tab(_ref7) {
  var children = _ref7.children,
      onClick = _ref7.onClick,
      nav = _ref7.nav,
      selected = _ref7.selected;
  return _react2.default.createElement(Container, {
    nav: nav,
    selected: selected,
    onClick: onClick
  }, children);
};

Tab.propTypes = {
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  nav: _propTypes2.default.bool,
  selected: _propTypes2.default.bool
};
exports.default = Tab;